export const FETCH_STORIES = "fetchStories";
export const FETCH_USER_STORIES = "fetchUserStories";
export const RESET_USER_STORIES = "resetUserStories";
export const DELETE_STORY_FROM_USER = "deleteStoryFromUser";
